var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.userData
    ? _c(
        "span",
        {
          ref: "tooltipRef",
          staticClass: "user-avatar",
          class: {
            "user-avatar-with-text": _setup.initials,
            "user-avatar-sm": _vm.isSmall,
          },
          attrs: {
            "data-bs-placement": _vm.tooltipPlacement,
            title: _setup.userData.displayName,
            "data-bs-toggle": "tooltip",
          },
        },
        [
          _setup.imgSrc
            ? _c("img", { attrs: { src: _setup.imgSrc, alt: "" } })
            : _vm._e(),
          _vm._v(" "),
          _setup.initials
            ? _c("span", [_vm._v(_vm._s(_setup.initials))])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }